export class MovementGraph {
    constructor() {
        this.nodes = [];
        this.edges = [];
        this.bgLayer = null;
    }

    addEdge(n1, n2) {
        let edge = {
            n1, n2,
            length: Phaser.Point.distance(n1,n2)
        };
        this.edges.push(edge);
    }

    findAround(x, y, radius = 20, ignoreTiles = false) {
        let result = [];
        for (let edge of this.edges) {
            let {n1, n2} = edge;
            if (Phaser.Point.distance({x,y}, n1) < radius) {
                result.push({edge,  from: n1, to: n2, distance: Phaser.Point.distance({x,y}, n1)});
            }
            if (Phaser.Point.distance({x,y}, n2) < radius) {
                result.push({edge, from: n2, to: n1, distance: Phaser.Point.distance({x,y}, n2)});
            }
        }
        result.sort((a,b) => a.distance - b.distance);
        let withoutTilesOnWay = result.filter(r => {
            let tilesOnWay = this.bgLayer.getRayCastTiles(
                new Phaser.Line(x, y, r.to.x, r.to.y),
                undefined, true
            );
            if (tilesOnWay.length) {
                //console.log('point filtered out');
            }
            return tilesOnWay.length === 0;
        });
        if (withoutTilesOnWay.length > 0 || !ignoreTiles) return withoutTilesOnWay;

        return result;
    }
}

export class Mover {

    constructor(sprite, graph) {
        this.sprite = sprite;
        this.graph = graph;
        this.movement = null;
        this.lastEdge = null;
    }

    get isMoving() { return this.sprite.body.isMoving; }

    moveRandomExceptLastEdge(radius = 30, ignoreTiles = false) {
        let edgeSelected = null;
        let edgesAround = this.graph.findAround(this.sprite.centerX, this.sprite.bottom, radius, ignoreTiles);
        if (edgesAround.length === 0) {
            //console.warn("Cannot move anywhere - no edge around", this.sprite.centerX, this.sprite.centerY, this.sprite.type, radius);
            if (!ignoreTiles) {
                return this.moveRandomExceptLastEdge(100, true);
            } else {
                this.stuck = true;
                console.warn("Cannot move anywhere from", this.sprite.centerX, this.sprite.bottom);
                return;
            }
        } else if (edgesAround.length === 1){
            edgeSelected = edgesAround[0];
        } else {
            edgeSelected = game.rnd.pick(edgesAround.filter(e => e.edge !== this.lastEdge));
            if (!edgeSelected) edgeSelected = edgesAround[0];
        }
        //console.log(this.sprite.centerX, this.sprite.centerY, edgeSelected.from.x, edgeSelected.from.y, '->',  edgeSelected.to.x, edgeSelected.to.y,);
        this.moveTo(edgeSelected.edge, edgeSelected.to);
    }

    moveTo(edge, point) {
        this.lastEdge = edge;
        this.targetPoint = point;
        let speed = this.sprite.movingSpeed;
        this.sprite.body.moveTo(edge.length / speed * 1000,
            Phaser.Point.distance(this.sprite.centerPoint, point),
            game.math.radToDeg(Phaser.Point.angle(point, this.sprite.centerPoint))
        );
    }

    update() {
        if (!this.isMoving) return;
        if (Phaser.Point.distance(this.sprite, this.targetPoint) < 5) {
            this.stop();
        }
    }

    stop() {
        if (this.isMoving) {
            this.sprite.body.stopMovement(true);
            this.sprite.body.velocity.set(0);
        }
    }


}


// WEBPACK FOOTER //
// ./src/states/mover.js